import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { HashRouter, Routes, Route, useLocation } from "react-router-dom";
import { MotionConfig } from "framer-motion";
import { useEffect } from "react";
import Home from "./pages/Home";
import Platform from "./pages/Platform";
import Assistants from "./pages/Assistants";
import ForBusiness from "./pages/ForBusiness";
import Schools from "./pages/Schools";
import FamilyAccess from "./pages/FamilyAccess";
import Partners from "./pages/Partners";
import About from "./pages/About";
import Contact from "./pages/Contact";
import { ROUTE_PATHS } from "./lib/index";

const queryClient = new QueryClient();

function ScrollToTop(): null {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <MotionConfig reducedMotion="user">
        <HashRouter>
          <ScrollToTop />
          <Routes>
            <Route path={ROUTE_PATHS.HOME} element={<Home />} />
            <Route path={ROUTE_PATHS.PLATFORM} element={<Platform />} />
            <Route path={ROUTE_PATHS.ASSISTANTS} element={<Assistants />} />
            <Route path={ROUTE_PATHS.FOR_BUSINESS} element={<ForBusiness />} />
            <Route path={ROUTE_PATHS.SCHOOLS} element={<Schools />} />
            <Route path={ROUTE_PATHS.FAMILY_ACCESS} element={<FamilyAccess />} />
            <Route path={ROUTE_PATHS.PARTNERS} element={<Partners />} />
            <Route path={ROUTE_PATHS.ABOUT} element={<About />} />
            <Route path={ROUTE_PATHS.CONTACT} element={<Contact />} />
          </Routes>
        </HashRouter>
      </MotionConfig>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
